//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.js";
import "../Features/Features.FeatureBuilder.js";
import "../GeometricUtilities/GeometricUtilities.CurveFitOptions.js";
import "../no/Expression.js";
import "../no/Section.js";
import "../GeometricUtilities/GeometricUtilities.OnPathDimensionBuilder.js";
import "../no/Expression.js";
import "../no/GeometricUtilities.js";
import "../no/Section.js";
let d=[[[0,"Associative",1,0],[1,"CurveFitMethod",0,"GeometricUtilities.CurveFitOptions",0],[1,"CylinderRadius",0,"Expression",0],[0,"DirectionOption",1,0],[0,"DistanceTolerance",1,0],[1,"FirstCurve",0,"Section",0],[1,"PointArclength",0,"GeometricUtilities.OnPathDimensionBuilder",0],[0,"RadiusOption",1,0],[1,"SecondCurve",0,"Section",0],[0,"ShapeControlFirstCurve",1,0],[0,"ShapeControlSecondCurve",1,0],[0,"Vector",1,"Direction",0]],[[[],"ComplementArc",{},0,0],[[],"Evaluate",{},0,0]],[]];
SPLM.Features.CircularBlendCurveBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.CircularBlendCurveBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.CircularBlendCurveBuilder.CylinderDirectionOption = Object.freeze({
    "BestFit" : "BestFit", "Variable" : "Variable", "Vector" : "Vector", "CurrentView" : "CurrentView"});

SPLM.Features.CircularBlendCurveBuilder.CylinderRadiusOption = Object.freeze({
    "PointOnFirstCurve" : "PointOnFirstCurve", "PointOnSecondCurve" : "PointOnSecondCurve", "Value" : "Value"});

export default SPLM;